import { Pipe, PipeTransform } from '@angular/core';
import {
  EmployeeRequestResponsibleForAnswerStatusEnum,
  EmployeeRequestResponsibleForAnswerStatusLabels,
} from '../enums/employee-request-responsible-for-answer-status.enum';

@Pipe({
  name: 'employeeRequestResponsibleForAnswerStatus',
  pure: true,
})
export class EmployeeRequestResponsibleForAnswerStatusPipe implements PipeTransform {
  transform(value: EmployeeRequestResponsibleForAnswerStatusEnum): string {
    return EmployeeRequestResponsibleForAnswerStatusLabels[value];
  }
}
